import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {SVGICONS} from '@ey/icons';
import {useDispatch, useSelector} from 'react-redux';
import {currentResource, labels} from '../../utils/utils';
import {clearErrors} from '../../errors';

export function ErrorSummary(props) {
	const [opened, setOpened] = useState(false),
		[message, setMessage] = useState(errorMessage);
	const hideError = () => {
		setOpened(!opened);

		dispatch(clearErrors()).then(() => {
			setOpened(false);
		});
	};

	const errorMessage = useSelector((store) => {
		return (
			store.errors.message ||
			(typeof store.errors === 'string' && store.errors) ||
			undefined
		);
	});

	const dispatch = useDispatch();

	useEffect(() => {
		let m = errorMessages(errorMessage);
		if (m === 'Network Error') {
			m = labels.NetworkErrorMessage;
		}
		setMessage(m);
	}, [errorMessage]);

	const getErrorCodeValue = (errorCodes) => {
		let errors = [];

		if (errorCodes.length > 0) {
			for (let i = 0; i < errorCodes.length; i++) {
				errors.push(
					errorCodes[i] + ': ' + currentResource.errors[errorCodes[i]]
				);
			}
			return errors;
		} else return errorCodes;
	};

	const errorMessages = (errors) => {
		let errorCodes = [];
		let errorMessages = [];
		let error;
		let message = '';
		let errorMessage = '';

		try {
			if (errors.indexOf(' - ') > 0) {
				error = errors.substr(0, errors.indexOf(' -'));
			} else {
				error = JSON.parse(errors);
			}
		} catch (err) {
			message = errors;
		}

		if (error) {
			if (error.length > 0 && Array.isArray(error)) {
				error.map((error) => {
					if (error.ErrorCode) {
						errorCodes.push(error.ErrorCode);
					} else {
						errorMessages.push(error.Message);
					}
				});
			} else {
				if (error.ErrorCode) {
					errorCodes.push(error.ErrorCode);
				} else {
					errorCodes.push(Number(error));
				}
			}

			if (errorCodes.length !== 0) {
				errorMessages = getErrorCodeValue(errorCodes);
				if (errorMessages.length > 0) {
					errorMessages.map((message) => {
						errorMessage += message;
					});
					return errorMessage;
				}
			}

			if (errorMessages.length > 0) {
				errorMessages.map((message) => {
					errorMessage += message;
				});
				return errorMessage;
			}
		} else {
			return message;
		}
	};

	return (
		<>
			{message ? (
				<StyledErrorContainer
					className={`
                             ${'errorMessageWrapper'}
                             ${opened ? 'hide-error-summary' : ' '}
                         `}
				>
					<span className="error-icon" />
					<span className="error-message">{message}</span>
					<SVGICONS
						styleName="medium pull-right close-icon"
						hoverText={labels.closeLabel}
						name="close-outline"
						onIconClick={hideError}
					/>
				</StyledErrorContainer>
			) : null}
		</>
	);
}

export default ErrorSummary;

const StyledErrorContainer = styled.section`
	padding: 0;
	color: ${(props) => props.theme.color[`grey500`]};
	width: calc(100% - 4rem);
	font-size: 1.2rem;
	line-height: 1.8rem;
	border: 0.1rem solid ${(props) => props.theme.color[`grey400`]};
	margin: 0 0 1.5rem 1.75rem;
	position: relative;
	display: table;
	background: ${(props) => props.theme.color[`white`]};
	box-shadow: 0.1rem 0.1rem 0.4rem ${(props) => props.theme.color[`grey300`]};
	&.hide-error-summary {
		display: none;
	}

	.close-icon {
		cursor: pointer;
		position: absolute;
		right: 0.9rem;
		top: 0.9rem;
		fill: ${(props) => props.theme.color[`grey500`]};
	}

	.error-message {
		display: inline-block;
		padding: 0.9rem 1rem 0.5rem;
		color: ${(props) => props.theme.color[`grey500`]};
		background: ${(props) => props.theme.color[`white`]};
		width: calc(100% - 3rem);
	}
`;
